import React, {FC, useEffect, useState} from "react"

import {Deal} from "@irati/types"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import isWalletBalanceApplicable from "@irati/deals/helpers/isWalletBalanceApplicable"
import visaLogo from "@irati-web/payments/src/images/visa.svg"
import mastercardLogo from "@irati-web/payments/src/images/mastercard.svg"
import maestroLogo from "@irati-web/payments/src/images/maestro.svg"
import idealLogo from "@irati-web/payments/src/images/ideal.svg"
import paypalLogo from "@irati-web/payments/src/images/logoPaypal.png"
import googlepayLogo from "@irati-web/payments/src/images/googlepay.svg"
import bancontactLogo from "@irati-web/payments/src/images/bancontact.svg"
import getCurrencyForDeal from "@irati/deals/helpers/deals/currency"
import WalletBallance from "@irati/wallet/apollo/query/Wallet"
import authentication from "@irati/auth"
import {isPaymentRequired} from "@irati/deals/helpers/redemption/deal"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

import {PaymentAvailability, getPaymentOptions} from "@irati/utils/payment/isPaymentAvailable"
import {Image} from "./styled/ImportantInfoBlock"
import WalletSpendBalance from "./WalletSpendBalance"

interface Props extends WithPerkOrReward {
  deal: Deal
}

const CashDealType: FC<Props> = ({deal, isRewards}) => {
  const [paymentOptions, setPaymentOptions] = useState<PaymentAvailability>({mc: true, visa: true})
  const [paymentOptionsHeader, setPaymentOptionsHeader] = useState<string>("perks.dealInfo.importantInfo.noWalletBalance.payWith")
  useEffect(() => {
    getPaymentOptions(getCurrencyForDeal(deal)).then((options) => {
      setPaymentOptions(options)
    })
  }, [])

  if (!isPaymentRequired(deal) || deal.isTTDeal || isRewards) {
    return null
  }
  const userId = authentication.user().uuid
  const hasCashWallet = authentication.apps("wallet.users")

  return (
    <>
      {hasCashWallet && (
        <WalletBallance variables={{userId, currency: getCurrencyForDeal(deal)}} useLoader={false}>
          {({data}) => {
            const wallet = data!.wallet
            const hasWalletBalance = isWalletBalanceApplicable(deal, wallet)
            if (!hasWalletBalance) {
              return null
            }
            setPaymentOptionsHeader("perks.dealInfo.importantInfo.walletBalance.youCanAlsoPayWith")

            return <WalletSpendBalance wallet={wallet} />
          }}
        </WalletBallance>
      )}

      <section>
        <Flex direction="row" justifyContent="center" alignContent="center">
          <Body>
            <FormattedMessage id={paymentOptionsHeader} />
          </Body>
        </Flex>
        <Flex justifyContent="center" alignContent="center" marginBottom={1}>
          {paymentOptions.googlepay && <Image src={googlepayLogo} />}
          {paymentOptions.mc && <Image src={mastercardLogo} />}
          {paymentOptions.visa && <Image src={visaLogo} />}
          {paymentOptions.maestro && <Image src={maestroLogo} />}
          {paymentOptions.ideal && <Image src={idealLogo} />}
          {paymentOptions.paypal && <Image src={paypalLogo} />}
          {paymentOptions.bancontact && <Image src={bancontactLogo} />}
        </Flex>
      </section>
    </>
  )
}

export default withPerkOrReward(CashDealType)
